import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import { t } from "i18next";
import { Navbar } from "../components/Navbar/Navbar";
import { Link } from "react-router-dom";
import logo from "../assets/logo.png";
import Footer from "../components/Footer/Footer";
import i18next from "i18next";


const documents = [
  { title: t("Anti-Corruption Policy"), file: "/files/anticorruption.pdf" },
  { title: t("Human resources policy"), file: "/files/resource.pdf" },
  { title: t("Child Protection Policy"), file: "/files/child_protection.pdf" },
  { title: t("Procurement Policy"), file: "/files/procurement.pdf" },
  { title: t("Gender Equality Order"), file: "/files/Gender _policy.pdf" },
  { title: t("Policy on preventing and combating discrimination, sexual exploitation, violence and harassment"), file: "/files/discrimination.pdf" },
  { title: t("Project management policy"), file: "/files/management.pdf" },
  // додай більше при потребі
];

export const  FundPolicies = () => {
  return (
    <div className="FundPoliciesPage">
      <Navbar color="menu-wrap" />
      <Container>
        
        <h1 className="mb-4 mt-4 fw-bold" style={{ color: "#4c94ff" }}>
          {t("politycs")}
        </h1>
        <p style={{ fontSize: "2rem"}}>
        {t("politycsh_p")}
        </p>
        <p style={{ fontSize: "2rem"}}>
        {t("politycsh_p1")}
        </p>
        <p style={{ fontSize: "2rem"}}>
        {t("politycsh_p2")}
        </p>
        <p style={{ fontSize: "2rem"}}>
        {t("politycsh_p3")}
        </p>
        <p style={{ fontSize: "2rem"}}>
        {t("politycsh_p4")}
        </p>
        <Row className="mt-4 g-3">
          {documents.map((doc, idx) => (
            <Col xs={12} md={6} lg={4} key={idx}>
              <a style={{ fontSize: "2rem"}}
                href={doc.file}
                target="_blank"
                rel="noopener noreferrer"
                className="d-block p-3 bg-light border rounded text-decoration-none h-100 shadow-sm"
              >
                📄 {t(doc.title)}
              </a>
            </Col>
          ))}
        </Row>
      </Container>
      <Footer />
    </div>
  );
};

export default FundPolicies;